import { render } from "./RegisterApelido.vue?vue&type=template&id=1b9e3133"
import script from "./RegisterApelido.vue?vue&type=script&lang=js"
export * from "./RegisterApelido.vue?vue&type=script&lang=js"
script.render = render

export default script